<template>
  <generic-container
    :title="$t('datasource manager')"
    icon="chart bar"
    :show_plus="true"
    @add="add"
  >
    <div class="ui three cards">
      <div class="card" v-for="(ds, index) in datasources" :key="index">
        <div class="content">
          <img class="right floated mini ui image" src="/images/icons/data_source.png" />
          <div class="header">{{ ds.name}}</div>
          <div class="meta">{{ ds.description }}</div>
        </div>
        <div class="ui bottom attached basic icon buttons">
          <div :data-tooltip="$t('edit')" class="ui button" @click="edit(ds)">
            <i class="edit icon"></i>
          </div>
          <div :data-tooltip="$t('permissions')" class="ui button" @click="permissions(ds)">
            <i class="blue user lock icon"></i>
          </div>
          <div :data-tooltip="$t('delete')" class="ui button" @click="remove(ds, index)">
            <i class="red trash icon"></i>
          </div>
        </div>
      </div>
    </div>
    <template v-for="(mdl, index) in modals">
      <component
        :is="mdl"
        :key="index"
        :datasource="selected_datasource"
        v-on:destroy="destroy"
        v-on:succedded="succedded"
      ></component>
    </template>
    <template v-for="(mdl, index) in permission_modals">
      <component
        :is="mdl"
        :key="index"
        :datasource="selected_datasource"
        v-on:destroy="destroy"
        v-on:succedded="succedded"
      ></component>
    </template>
  </generic-container>
</template>

<script>
import { local_api, error_toast } from "@/utils";
import filters from "@/filters";
import GenericContainer from "@/components/GenericContainer";
import DatasourceModal from "./DatasourceModal";
import DatasourcePermissionModal from "./DatasourcePermissionModal";

export default {
  name: "DataSourceManagement",
  props: {},
  components: {
    "generic-container": GenericContainer
  },
  filters: filters,
  data() {
    return {
      datasources: [],
      modals: [],
      permission_modals: [],
      selected_datasource: undefined
    };
  },
  methods: {
    add() {
      this.modals.push(DatasourceModal);
    },
    remove(datasource, index) {
      let vm = this;
      vm.$alertify.confirm(
        vm.$t("are you sure to delete datasource?"),
        function() {
          local_api(vm, "post", "/ngine_core/datasource/do-remove", {
            i: datasource.uuid
          })
            .then(() => {
              vm.datasources.splice(index, 1);
            })
            .catch(err => {
              error_toast(err);
            });
        },
        function() {}
      );
    },
    destroy() {
      this.modals = [];
      this.permission_modals = [];
      this.selected_datasource = undefined;
    },
    succedded(datasource) {
      let vm = this;
      let trgt = vm.datasources.find(n => n.uuid == datasource.uuid);
      if (trgt) {
        trgt.name = datasource.name;
        trgt.description = datasource.description;
        trgt.setup.fields = datasource.setup.fields;
      } else vm.datasources.push(datasource);
    },
    edit(datasource) {
      this.selected_datasource = datasource;
      this.modals.push(DatasourceModal);
    },
    permissions(datasource) {
      this.selected_datasource = datasource;
      this.permission_modals.push(DatasourcePermissionModal);
    }
  },
  created() {},
  mounted() {
    let vm = this;
    local_api(this, "post", "/ngine_core/datasource/do-get-list")
      .then(datasources => {
        let _datasources = datasources.sort(function(a, b) {
          if (a.name > b.name) return 1;
          if (b.name > a.name) return -1;
          return 0;
        });

        vm.datasources = _datasources;
      })
      .catch(err => {
        error_toast(err);
      });
  },
  watch: {}
};
</script>
